import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import * as registerServiceWorker from './registerServiceWorker';
import swConfig from './swConfig';
import { getAPIURL } from './server/api';
import { applyHostBranding } from './utils/hostBranding';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment:
    getAPIURL() === 'https://api.qa.oqdigital.com' ? 'QA' : 'production',
});

applyHostBranding();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
registerServiceWorker.register(swConfig);
